import axios from 'axios';
import { logger } from 'helpers';
import { serializer, toast } from 'helpers';
import i18next from 'i18next';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export const coreInstance = axios.create({
	baseURL:
		`${process.env.REACT_APP_CORE_API_URL}${process.env.REACT_APP_API_VERSION}` ||
		'/api/v1/',
	paramsSerializer: (params) => {
		return serializer(params);
	},
});

export const patientInstance = axios.create({
	baseURL:
		`${process.env.REACT_APP_PATIENT_API_URL}${process.env.REACT_APP_API_VERSION}` ||
		'/api/v1/',
	paramsSerializer: (params) => {
		return serializer(params);
	},
});

export const authInstance = axios.create({
	baseURL:
		`${process.env.REACT_APP_AUTH_API_URL}${process.env.REACT_APP_API_VERSION}` ||
		'/api/v1/',
	paramsSerializer: (params) => {
		return serializer(params);
	},
});

const removeBrowserStorage = () => {
	localStorage.clear();
	sessionStorage.removeItem('access_token');
	sessionStorage.removeItem('expires_in');
	sessionStorage.removeItem('refresh_token');
	sessionStorage.removeItem('remember_me');

	cookies.remove('access_token');
	cookies.remove('refresh_token');
	cookies.remove('expires_in');
	cookies.remove('saml_login');
	cookies.remove('remember_me');
};

coreInstance.interceptors.response.use(
	(response) => {
		logger('[Axios - Core] Set axios response interceptors');

		return response;
	},
	(error) => {
		logger('[Axios - Core] Set axios response interceptors fail');

		const { status } = error.response;

		if (status === 401 || status === 403) {
			const isLoggedIn =
				localStorage.getItem('access_token') ||
				sessionStorage.getItem('access_token');

			removeBrowserStorage();
			if (isLoggedIn) window.location = '/';
		}

		if (status >= 500) toast.error(i18next.t('oops_something_went_wrong'));

		return Promise.reject(error);
	},
);

patientInstance.interceptors.response.use(
	(response) => {
		logger('[Axios - Patient] Set axios response interceptors');

		return response;
	},
	(error) => {
		logger('[Axios - Patient] Set axios response interceptors fail');

		const { status } = error.response;

		if (status === 401 || status === 403) {
			const isLoggedIn =
				localStorage.getItem('access_token') ||
				sessionStorage.getItem('access_token');

			removeBrowserStorage();
			if (isLoggedIn) window.location = '/';
		}

		if (status >= 500) toast.error(i18next.t('oops_something_went_wrong'));

		return Promise.reject(error);
	},
);

authInstance.interceptors.response.use(
	(response) => {
		logger('[Axios - Auth] Set axios response interceptors');

		return response;
	},
	(error) => {
		logger('[Axios - Auth] Set axios response interceptors fail');

		const { status } = error.response || {};

		if (status === 401 || status === 403) {
			const isLoggedIn =
				localStorage.getItem('access_token') ||
				sessionStorage.getItem('access_token');

			removeBrowserStorage();
			if (isLoggedIn) window.location = '/';
		}

		if (status >= 500) toast.error(i18next.t('oops_something_went_wrong'));

		return Promise.reject(error);
	},
);

export default coreInstance;
